
import {
    SHOW_EXIT_AUDIT_SUCCESS
  } from '../actions/types';
  
  const INITIAL_STATE = {
    exitAudit: null
  };
  
  export default function exitAuditReducer (state=INITIAL_STATE, action) {

    switch (action.type) {
      case SHOW_EXIT_AUDIT_SUCCESS:
        return { ...state, exitAudit: action.payload.exit_audit };
      default:
        return state;
    }
  };